// src/components/WebSocketHeartbeatHolder.tsx
import React from 'react';
import useWebSocketHeartbeat from './useWebSocketHeartbeat';

const WebSocketHeartbeatHolder: React.FC<{ userId?: number }> = ({ userId }) => {
  useWebSocketHeartbeat(userId?.toString());
  return null;
};

export default WebSocketHeartbeatHolder;
